import { VETERAN_TYPE } from '@nerdwallet/home-constants';

import Input from '../inputs/input';
import * as inputDefinitions from '../../config/inputs';

import truncatedValidatorMessage from '../../config/truncatedValidatorMessage';

const downPayment = new Input(inputDefinitions.downPayment);
// Overriding because no home price in this context because we're calculating the home price
downPayment.validators = [
  (data) => {
    if (data.downPayment > 10000000) {
      return {
        valid: false,
        message: 'Value must be less than $10,000,000',
      };
    }
    return {
      valid: true,
      message: '',
    };
  },
];

// Overrides
const insurance = new Input(inputDefinitions.homeownersInsurance);
const propertyTax = new Input(inputDefinitions.propertyTax);
const HOADues = new Input(inputDefinitions.HOADues);
const mortgageInsurance = new Input(inputDefinitions.mortgageInsurance);
insurance.validators = [truncatedValidatorMessage.bind(insurance)];

propertyTax.validators = [truncatedValidatorMessage.bind(propertyTax)];

HOADues.validators = [truncatedValidatorMessage.bind(HOADues)];

mortgageInsurance.validators = [
  truncatedValidatorMessage.bind(mortgageInsurance),
];

const inputLibrary = {
  annualInterestRate: new Input(inputDefinitions.annualInterestRate),
  city: new Input(inputDefinitions.city),
  closingCosts: new Input(inputDefinitions.closingCosts),
  downPayment,
  HOADues,
  loanTerm: new Input(inputDefinitions.loanTerm),
  income: new Input(inputDefinitions.income),
  homeownersInsurance: insurance,
  mortgageInsurance,
  monthlyDebt: new Input(inputDefinitions.monthlyDebt),
  propertyTax,
  veteranType: new Input({
    name: 'veteranType',
    required: false,
    type: 'string',
    whitelist: VETERAN_TYPE,
  }),
  firstVaLoan: new Input({
    name: 'firstVaLoan',
    required: false,
    type: 'boolean',
  }),
  purchasePrice: new Input(inputDefinitions.purchasePrice),
};

export default inputLibrary;
